import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mt-3" }
const _hoisted_2 = { class: "col-xs-1 col-md-4" }
const _hoisted_3 = { class: "col-xs-1 mt-xs-2 col-md-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.detectFile && _ctx.detectFile(...args))),
        name: "file",
        type: "file",
        class: "form-control",
        accept: "image/*",
        capture: "camera"
      }, null, 32)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "btn btn-primary mr-3 mt-xs-2",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addInput && _ctx.addInput(...args)))
      }, "+"),
      _createElementVNode("button", {
        class: "btn btn-danger mx-2",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeInput && _ctx.removeInput(...args)))
      }, "-")
    ])
  ]))
}